import { AccountApi, ApiClient, Routes, Session, ISessionResponse, ISessionForgotPasswordRequest, ISessionResetPasswordRequest, ISuccessResponse, UserApi, IShipUserResponse } from "../../Types"

export interface AccountInvitationResponse {
  account: string;
  email: string;
  inviter: string;
  name: string;
  ship: string;
}

export const LoginViewData = {
  confirmEmail(api: ApiClient, token: string): Promise<ISessionResponse> {
    return new AccountApi(api).signup.confirmEmail({ params: { token } }).call();
  },
  resetApp(api: ApiClient) {
    return new Routes(api).app.reset({ params: {} }).call();
  },
  loadInvitation(api: ApiClient, token: string) {
    return new AccountApi(api).signup.invitation({ params: { token } }).call();
  },
  // Existing-account ship invitation: same response shape as the brand-new-user
  // signup invitation above (an AccountInvitationResponse), just looked up from a
  // pending ShipUser rather than a pending User.
  loadShipInvitation(api: ApiClient, token: string): Promise<AccountInvitationResponse> {
    return new UserApi(api).shipUsers.invitation({ params: { token } }).call();
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  login(api: ApiClient, values: any): Promise<ISessionResponse> {
    return new Session(api).session.create({ params: {}, body: values }).call();
  },
  handoff(api: ApiClient, state: string) {
    return new Session(api).session.handoff({ params: {}, body: { state } }).call();
  },
  exchange(api: ApiClient, code: string, state: string) {
    return new Session(api).session.exchange({ params: {}, body: { code, state } }).call();
  },
  forgotPassword(api: ApiClient, values: ISessionForgotPasswordRequest) {
    return new Session(api).session.forgotPassword({ params: {}, body: values }).call();
  },
  resetPassword(api: ApiClient, token: string, values: ISessionResetPasswordRequest): Promise<ISuccessResponse> {
    return new Session(api).session.resetPassword({ params: { token }, body: values }).call();
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  acceptInvitation(api: ApiClient, token: string, values: any): Promise<ISessionResponse> {
    return new AccountApi(api).signup.acceptInvitation({ params: { token }, body: values }).call();
  },
  // Attaches the current session's user (and their pending account membership) to
  // the ship they were invited to. Requires an authenticated session; the server
  // checks the invited user matches the session's user (401 otherwise).
  acceptShipInvitation(api: ApiClient, token: string): Promise<IShipUserResponse> {
    return new UserApi(api).shipUsers.acceptInvitation({ params: { token } }).call();
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  createAccount(api: ApiClient, values: any) {
    return new AccountApi(api).account.create({ params: {}, body: values }).call();
  },
  deleteSession(api: ApiClient) {
    return new Session(api).session.delete({ params: {} }).call();
  },

  // Signup form validity: name, email and a >=3 char password are required, plus an
  // account name once the server has reported the account already exists.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  validateSignup(values: any, signupError?: string): boolean {
    return !!(values.name && values.name.length > 0
      && values.email && values.email.length > 0
      && values.password && values.password.length >= 3
      && (signupError != "signupAccountAlreadyExists" || (values.accountName && values.accountName.length > 0)));
  },
};
